export const LESS_ONE = 'До одного року';
export const FROM_ONR_TO_TWO = 'До двох років';
export const FROM_TWO_TO_THREE = 'До трьох років';
export const FROM_FOUR_TO_FIVE_TITLE = `До п'яти років`;
export const SIX_AGE_TITLE = 'До шести років і більше';

export const AGE_ARRAY = [
    LESS_ONE, FROM_ONR_TO_TWO, FROM_TWO_TO_THREE, FROM_FOUR_TO_FIVE_TITLE, SIX_AGE_TITLE
];

export const AGE_NAMES = [
    {
        value: 'less 1',
        text: LESS_ONE
    },
    {
        value: 'from 1 to 2',
        text: FROM_ONR_TO_TWO
    },
    {
        value: 'from 2 to 3',
        text: FROM_TWO_TO_THREE
    }
]